var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listContainer"},_vm._l((_vm.videosList),function(index,key){return _c('div',{staticClass:"videoItem",style:({ backgroundColor:index.backgroundCol }),on:{"click":function($event){_vm.openVideo(index)}}},[_vm._v("\r\n        "+_vm._s(index.name)+"\r\n    ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4032aca3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/Dynamic/app/videos_insanity/listOfVideos.vue
// module id = 630
// module chunks = 0